import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreLink?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreLink,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3 md:mb-8">
      <div>
        {eyebrow ? (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-accent-600">
            <i className="ri-record-circle-line" />
            {eyebrow}
          </span>
        ) : null}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description ? <p className="mt-2 max-w-2xl text-sm text-foreground-600">{description}</p> : null}
      </div>
      {moreLink ? (
        <Link
          to={moreLink}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      ) : null}
    </div>
  );
}